/*
 * Copyright (c) 2022 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

/* eslint-disable no-console */
import { XError } from '@wit/vtv-x-foundation-lib';

/**
 * Production Logger
 * WARNING: Do not log sensitive information.
 */
export default class Logger {
  static error(xError: XError) {
    console.error(xError.translation);
  }
}
